"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.errorBreak = exports.errorLog = exports.warnLog = exports.commonLog = undefined;

var _reactPureCheck = require("react-pure-check"); // 偏函数处理
// local function dose not need to judge param


var Log = function Log() {
  var typeFn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
  return function () {
    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var a = arguments[1];
    var b = arguments[2];
    var c = arguments[3];
    var d = arguments[4];
    var e = arguments[5];
    var f = arguments[6];
    var args = [a, b, c, d, e, f];
    var argIndex = 0;
    var replaceMessage = message.replace(/%s/g, function () {
      return args[argIndex++];
    });
    return (0, _reactPureCheck.Types)(typeFn) === "function" && typeFn(replaceMessage);
  };
}; // define different log

/*
	intro : common log defination
	Author : chenchao
	Date : 2019-06-17
*/


var commonLog = Log(console.log);
var warnLog = Log(console.warn);
var errorLog = Log(console.error); // throw a error 

function errorBreak() {
  var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var a = arguments[1];
  var b = arguments[2];
  var c = arguments[3];
  var d = arguments[4];
  var e = arguments[5];
  var f = arguments[6];
  var error = void 0;

  if (message === undefined) {
    error = new Error('Param exception occurred;');
  } else {
    var args = [a, b, c, d, e, f];
    var argIndex = 0;
    error = new Error(message.replace(/%s/g, function () {
      return args[argIndex++];
    }));
    error.name = 'Param Violation';
  }

  error.framesToPop = 1; // we don't care about Param's own frame

  throw error;
}

exports.commonLog = commonLog;
exports.warnLog = warnLog;
exports.errorLog = errorLog;
exports.errorBreak = errorBreak;